import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRoutes } from './ApiRoutes';
import { Gt2ApiService } from './gt2-api.service';

/** Fonctionnalités [PRO] cochables — mêmes valeurs que UpgradeInterestEnum côté API. */
export type UpgradeInterest = 'SUBMISSIONS' | 'AUTOMATIONS' | 'INTEGRATIONS';

export interface UpgradeRequestPayload {
  message: string;
  interests: UpgradeInterest[];
}

/** Paywall — formulaire « Demander une mise à niveau » (courriel interne à l'équipe GT). */
@Injectable({ providedIn: 'root' })
export class UpgradeRequestService {
  constructor(
    private http: HttpClient,
    private api: Gt2ApiService,
  ) {}

  public send(payload: UpgradeRequestPayload): Observable<any> {
    return this.http.post<any>(
      this.api.createUrl(ApiRoutes.PAYWALL_UPGRADE_REQUEST),
      payload,
    );
  }
}
